/**
 * Return true if YMM version is new
 */
export const ymmQuizIsNewVersion = (): boolean =>
  Number(window._env_.REACT_APP_YMM_OLD_VERSION) === 0
